"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletSelector = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _modal = require("./modal");

var _ProvideWallet = require("../context/ProvideWallet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Primary UI component for user interaction
 */
var WalletSelector = function WalletSelector(_ref) {
  var returnWallet = _ref.returnWallet,
      _ref$wallets = _ref.wallets,
      wallets = _ref$wallets === void 0 ? [] : _ref$wallets;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ProvideWallet.ProvideWallet, null, /*#__PURE__*/_react.default.createElement(SelectorContent, {
    returnWallet: returnWallet,
    validWallets: wallets
  })));
};

exports.WalletSelector = WalletSelector;

var SelectorContent = function SelectorContent(_ref2) {
  var returnWallet = _ref2.returnWallet,
      validWallets = _ref2.validWallets;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useWallet = (0, _ProvideWallet.useWallet)(),
      setValidWallets = _useWallet.setValidWallets;

  (0, _react.useEffect)(function () {
    setValidWallets(validWallets);
  }, [validWallets]);

  var closeModal = function closeModal(walletInfo) {
    setIsOpen(false);
    returnWallet(walletInfo);
  };

  var openModal = function openModal() {
    setIsOpen(true);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ws-flex ws-items-center ws-justify-center"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    onClick: openModal,
    className: "ws-px-4 ws-py-2 ws-text-sm ws-font-medium ws-text-white ws-bg-black ws-rounded-md ws-bg-opacity-100 ws-hover:bg-opacity-75 ws-focus:outline-none ws-focus-visible:ring-2 ws-focus-visible:ring-white ws-focus-visible:ring-opacity-75"
  }, "Connect wallet")), /*#__PURE__*/_react.default.createElement(_modal.Modal, {
    isOpen: isOpen,
    closeModal: closeModal
  }));
};

WalletSelector.propTypes = {
  returnWallet: _propTypes.default.func,
  wallets: _propTypes.default.array
};